// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox___1YyJK","text":"text___2R3cf"};